import CheckIcon from '@mui/icons-material/Check'
import { Box, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useMinimalsTheme, WarningIcon } from '../../../index'

interface YesNoBadgeProps {
  isYes: boolean
  isWarning?: boolean
}

export const YesNoBadge: FC<YesNoBadgeProps> = observer(({ isYes, isWarning }) => {
  const theme = useMinimalsTheme()

  isWarning ??= !isYes

  const label = isYes ? 'Yes' : 'No'

  const { Icon, backgroundColor, textColor } = isWarning
    ? {
        Icon: WarningIcon,
        backgroundColor: theme.palette.warning.lighter,
        textColor: theme.palette.warning.dark,
      }
    : {
        Icon: CheckIcon,
        backgroundColor: theme.palette.success.lighter,
        textColor: theme.palette.success.dark,
      }

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '65px',
        background: backgroundColor,
        padding: `${theme.customSpacing.xxs} ${theme.customSpacing.xs}`,
        borderRadius: theme.customRadius.medium,
      }}
    >
      <Typography
        variant='body2'
        sx={{
          display: 'flex',
          alignItems: 'center',
          fontWeight: 500,
          color: textColor,
          gap: theme.customSpacing.xxs,
        }}
      >
        <Icon sx={{ fontSize: '18px' }} />
        {label}
      </Typography>
    </Box>
  )
})
